import React from "react";

export default function SubTitle({ title, className = "" }) {
  return <p className={`${className} font-bold`}>{title}</p>; // <p className="text-lg font-bold">{title}</p>;
}
